<div class="loader-container" *ngIf="isLoading">
  <div class="loader"></div>
</div>

<div *ngIf="!isLoading">
  <ng-container *ngIf="(language$ | async)?.getCode() as locale">
    <span (click)="goBack()" class="btn btn-warning user-list-back-button">
      <em class="fa fa-chevron-left"></em>&nbsp;&nbsp;&nbsp;{{ 'H1' | translate : locale }}
    </span>

    <h2>{{ 'H2' | translate : locale }}</h2>

    <div class="font-color-red documents-list">
      <div *ngFor="let document of documents | async">
        <i class="fa fa-chevron-right" aria-hidden="true"></i>&nbsp;&nbsp;
        <span (click)="downloadFile(document)">{{ getFileName(document) }}</span>
      </div>
    </div>
  </ng-container>
</div>